import tracksFile from './tracks.json';
import { isVideoId } from './youtube';

// The music on the front page. Edit tracks.json: add YouTube links (or bare video
// ids), one per entry. Each visit plays them shuffled, in a different order, and
// skips any video that cannot be embedded.
//
//   "https://www.youtube.com/watch?v=VIDEOID"       a link, any common form
//   "VIDEOID"                                        a bare 11-character id
//   { "url": "...", "title": "...", "author": "..." } optional extra labels
//
// The entries below are placeholders: the first is the song from the shared
// playlist link, the others are very widely embedded videos so that *something*
// plays. Replace them with your own favourites.

const YOUTUBE_HOSTS = /^(www\.|m\.)?(youtube\.com|youtube-nocookie\.com)$/;

// Accepts a video id or a YouTube link in any common form; returns the id or null
export function parseVideoId(input) {
  if (typeof input !== 'string') return null;
  const text = input.trim();
  if (isVideoId(text)) return text;

  let url;
  try {
    url = new URL(text);
  } catch (error) {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;

  let id = null;
  if (url.hostname === 'youtu.be') {
    id = url.pathname.split('/')[1];
  } else if (YOUTUBE_HOSTS.test(url.hostname)) {
    const [, kind, rest] = url.pathname.split('/');
    id = ['embed', 'shorts', 'live', 'v'].includes(kind) ? rest : url.searchParams.get('v');
  }
  return isVideoId(id) ? id : null;
}

// -> [{ id, title, author }], skipping entries that are not videos and repeats
export function parseTracks(entries) {
  const seen = new Set();
  const tracks = [];
  for (const entry of Array.isArray(entries) ? entries : []) {
    const source = typeof entry === 'string' ? entry : entry && (entry.url || entry.id);
    const id = parseVideoId(source);
    if (!id || seen.has(id)) continue;
    seen.add(id);
    tracks.push({
      id,
      title: entry && typeof entry.title === 'string' ? entry.title : '',
      author: entry && typeof entry.author === 'string' ? entry.author : ''
    });
  }
  return tracks;
}

export const TRACKS = parseTracks(tracksFile);
